<header class="topbar">
  <!-- Left group: the drawer-toggle hamburger, anchored to the start edge
       (grid col 1). Only rendered in drawer mode (<=900px). -->
  <div class="topbar__left">
    <button
      type="button"
      class="topbar__hamburger"
      data-testid="nav-drawer-toggle"
      aria-label="Toggle navigation"
      (click)="nav.toggle()"
    >
      <span class="material-icons">menu</span>
    </button>
  </div>

  <!-- Address search, migrated from header.component.ts. Shown only on the
       project list pages (see showSearch) — it's a project search. -->
  <div class="topbar__search" *ngIf="showSearch">
    <input
      type="text"
      class="topbar__search__input"
      data-testid="topbar-search-input"
      placeholder="Search for an address"
      [(ngModel)]="searchTerm"
      (keyup.enter)="search()"
    />
    <button
      type="button"
      class="topbar__search__button"
      data-testid="topbar-search-submit"
      aria-label="Search"
      (click)="search()"
    >
      <span class="material-icons">search</span>
    </button>
    <button
      *ngIf="showClearSearchButton"
      type="button"
      class="topbar__search__clear"
      data-testid="topbar-search-clear"
      aria-label="Clear search"
      (click)="clearSearch()"
    >
      <span class="material-icons">close</span>
    </button>
  </div>

  <!-- Notifications, migrated from header.component.ts. -->
  <div class="topbar__bell">
    <button
      type="button"
      class="topbar__bell__trigger"
      data-testid="topbar-notifications"
      aria-label="Notifications"
      (click)="toggleNotificationsModal()"
    >
      <span
        class="topbar__bell__icon"
        [matBadge]="unreadNotifications?.length"
        [matBadgeHidden]="unreadNotifications?.length < 1"
        matBadgeColor="primary"
      >
        <span class="material-icons">notifications</span>
      </span>
    </button>

    <notification-dialog
      [active]="notificationsActive"
      (modalClosed)="toggleNotificationsModal()"
      (markAllAsRead)="markAllAsRead()"
      (markAsRead)="markAsRead($event)"
      (markAsUnread)="markAsUnread($event)"
      [readNotifications]="readNotifications"
      [unreadNotifications]="unreadNotifications"
      [projects]="projects"
    ></notification-dialog>
  </div>
</header>
